module.exports = __webpack_public_path__ + "assets/828656e9c4bd962786b92e725a813f2c.mp3";